export default {
  APP_ROOT_PATH: '/',
  // API_URL: 'http://localhost:44377',
  API_URL: 'https://beta-api.bookwiz.net',
  // API_URL: 'https://cbs-api.bookwiz.net',
  NO_RECORD_TEXT: 'No records found',
  USERTYPE_MAIN_ADMIN: 'Main Admin',
  USERTYPE_SCHOOL_ADMIN: 'School Admin',
  USERTYPE_INSTRUCTOR: 'Instructor',
  USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN: 'Instructor and School Admin',
  USERTYPE_STUDENT: 'Student',
  USERTYPE_OTHERS: 'Others',
  DEFAULT_COUNTRY: 'Singapore',
  DEFAULT_CURRENCY: 'SGD'
}


// WEBPACK FOOTER //
// ./src/config.js